module.exports = __webpack_public_path__ + "static/img/element.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/element.png
// module id = LDy4
// module chunks = 5